import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NotificationArgs, SabisNgxNotificationService, SabisToaster2Service } from 'sabis-components2';

@Injectable({
  providedIn: 'root'
})
export class AppNotificationsService {
  onShowNotificationNotice: Subject<NotificationArgs> = new Subject();

  constructor(
    private _toaster: SabisToaster2Service,
    private _notifications: SabisNgxNotificationService) { }

  public notifySaveSucceeded(): void {
    this._toaster.showSuccess('Saved successfully');
  }

  public notifyEmailSent(): void {
    this._toaster.showSuccess('Email Sent');
  }

  public notifySaveFailed(): void {
    this._toaster.showError('Save failed');
  }

  public notifyUnarchiveFailed(): void {
    this._toaster.showError('Unarchive failed');
  }

  public notifyDeleteFailed(): void {
    this._toaster.showError('Delete failed');
  }

  public notifyDeleteSucceeded(): void {
    this._toaster.showSuccess('Deleted successfully');
  }

  public showInvalidEntriesMessage(): void {
    this._toaster.showError('One or more invalid entries!');
  }

  public completeRequiredFieldMessage(): void {
    this._toaster.showError('Please complete the required fields.');
  }

  public confirmDeleteMessage(): Observable<boolean> {
    return this._notifications.confirm('Are you sure you want to delete this record?', 'Confirmation');
  }

  public confirmActivateDeactivateMessage(action: string): Observable<boolean> {
    return this._notifications.confirm(`Are you sure you want to ${action} this record?`, 'Confirmation');
  }

  public notifyRecordActivatedDeactivated(isDeactivated: boolean): void {
    this._toaster.showSuccess(isDeactivated ? `Activated successfully` : `Deactivated successfully`);
  }

  public confirmApproveMessage(field: string): Observable<boolean> {
    return this._notifications.confirm(`Are you sure you want to approve this ${field}?`, 'Confirmation');
  }

  public sameProfileSelectedMessage(profile: string): void {
    this._toaster.showError(`The same ${profile} can be selected only once.`);
  }

  public mandatorySelectionMessage(profile: string): void {
    this._toaster.showError(`Please select at least one ${profile}.`);
  }

  public confirmResendEmailMessage(): Observable<boolean> {
    return this._notifications.confirm('Are you sure you want to resend this email?', 'Confirmation');
  }

  public confirmCancelEmailMessage(): Observable<boolean> {
    return this._notifications.confirm('Are you sure you want to cancel this email?', 'Confirmation');
  }

  public confirmUnarchiveRequisitionMessage(requisitionTitle: string): Observable<boolean> {
    return this._notifications.confirm(`Are you sure you want to unarchive ${requisitionTitle}?`, 'Confirmation');
  }

  public confirmCompleteStep(): Observable<boolean> {
    return this._notifications.confirm('Are you sure you want to complete this step?', 'Confirmation');
  }

  public notifyRecordClosedUnarchived(isClosed: boolean): void {
    this._toaster.showSuccess(isClosed ? 'Unarchived successfully' : 'Closed successfully');
  }

  public notifyAccessDenied(): void {
    this._toaster.showError(`You do not have the needed access right. Please contact your system administrator.`);
  }

  public notifyCopiedToClipboard(): void {
    this._toaster.showSuccess('Copied to clipboard');
  }

  public unexpectedErrorOccurred(): void {
    this._toaster.showError('Unexpected error occurred');
  }

  public confirmDeleteFeedbackRequest(): Observable<boolean> {
    return this._notifications.confirm(`Are you sure you want to delete this request?`, 'Confirmation');
  }

  public confirmCancelRequest(): Observable<boolean> {
    return this._notifications.confirm(`Are you sure you want to cancel this request?`, 'Confirmation');
  }

  public notifySearchFailed(): void {
    this._toaster.showError('Search failed');
  }

  public notifyNoWorkflowForJobPosition(): void {
    this._toaster.showError('There is no workflow set for this Job Position. Please contact your administrator.');
  }

  public confirmPublishAnnouncementMessage(): Observable<boolean> {
    return this._notifications.confirm('Are you sure you want to publish this announcement?', 'Confirmation');
  }

  public confirmAnnouncementPublishActionMessage(isPublished: boolean): Observable<boolean> {
    const action = isPublished ? 'unpublish' : 'publish';
    return this._notifications.confirm(`Are you sure you want to ${action} this announcement?`, 'Confirmation');
  }

  public notifyInvalidFile(validationMessage: string): void {
    this._toaster.showError(`Invalid file uploaded: ${validationMessage}`);
  }

  public notifyInvalidWebistePopupDateRange(): void {
    this._toaster.showError(`End date must be greater than start date.`);
  }

  public notifyMissingOrInvalidPopupActionUrl(validationMessage: string): void {
    this._toaster.showError(validationMessage);
  }

  public notifyMissingPopupActionArea(actions: string): void {
    this._toaster.showError(`Please draw an area for these actions: ${actions}`);
  }

  public notifyMissingWebsitePopupImage(): void {
    this._toaster.showError(`Invalid input: Please upload an image for the website popup.`);
  }

  public notifyOnSaveAttemptWhileUploading(): void {
    this._toaster.showError(`Upload in progress. Please wait for the image to finish uploading, then try saving again.`);
  }

}
